
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/impressum",
      function () {
        return require("private-next-pages/[locale]/impressum.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/impressum"])
      });
    }
  